import React, { useState } from "react";
import { ERP_INVOICE_QUOTATION_TYPE } from "../../../core/constants/erpConstants";
import ListERPQuotation from "./ListERPQuotation";
import NewERPQuotation from "./NewERPQuotation";
import ViewERPQuotation from "./ViewERPQuotation";
import ProtectedComponent from "../../common/ProtectedComponent";
import ERPProductSearch from "../ERPProductSearch";
import { All_Component_Name, COMPONENT_TYPE_NULL } from "../../../shared/constants";

export default function ERPQuotation(props) {
  const [pageType, setPageType] = useState(
    ERP_INVOICE_QUOTATION_TYPE.LIST_OF_INVOICE_QUOTATION
  );
  const [selectedQuotation, setSelectedQuotation] = useState(null);

  const goToList = () => {
    setSelectedQuotation(null);
    setPageType(ERP_INVOICE_QUOTATION_TYPE.LIST_OF_INVOICE_QUOTATION);
  };
  const goToNew = () =>
    setPageType(ERP_INVOICE_QUOTATION_TYPE.NEW_INVOICE_QUOTATION);
  const goToView = (quotationRow) => {
    setSelectedQuotation(quotationRow);
    setPageType(ERP_INVOICE_QUOTATION_TYPE.VIEW_QUOTATION_INVOICE);
  };

  return (
    <>
      {ERP_INVOICE_QUOTATION_TYPE.LIST_OF_INVOICE_QUOTATION === pageType && (
        <ListERPQuotation
          {...props}
          onNewQuotation={goToNew}
          onViewQuotation={goToView}
        />
      )}

      {ERP_INVOICE_QUOTATION_TYPE.NEW_INVOICE_QUOTATION === pageType && (
        <NewERPQuotation
          {...props}
          onBackToList={goToList}
          viewOnly={false}
        />
      )}

      {ERP_INVOICE_QUOTATION_TYPE.VIEW_QUOTATION_INVOICE === pageType && (
        <ViewERPQuotation
          {...props}
          quotationData={selectedQuotation}
          onBackToList={goToList}
          viewOnly={true}
        />
      )}
    </>
  );
}
